import moment from "moment";
import { Definition, Entity, Property } from "../../data/Definition";
import { IDwDimension, IDwFilter, IDwMeasure, DwQuery, IFilter, IMeasure, IDimension } from "../../data/Query";
import { isEntity, isStats, isTimestampProperty } from "../../data/utils";


 class QueryProvider {
    getQuery(definition: Definition, config: any): null | DwQuery {
        let query = new DwQuery(definition.id!, definition.name, definition.feature);

        if(config.dimension) {
            this.getDimenstionQueryFromConfig(definition, Array.isArray(config.dimension) ? config.dimension : [config.dimension]).forEach((item: IDwDimension) => {
                query.addDimension(item);
            });
        }

        if(config.measure) {
            this.getMeasureQueryFromConfig(definition, Array.isArray(config.measure) ? config.measure : [config.measure]).forEach((item: IDwMeasure) => {
                query.addMeasure(item);
            });
        } 

        this.getFilterQueryFromConfig(definition, config.filters).forEach((item: IDwFilter) => {
            query.addFilter(item);
        });

        console.log('QueryProvider > convert query from config', JSON.stringify(query));

        return query;
    }

    getDimenstionQueryFromConfig(definition: Definition, config: IDimension[]): IDwDimension[] {
        let dims: any[] = [];

        if(config) {
            config.forEach((d: IDimension) => {
                if (d.source && d.source.item) {
                    if(isEntity(d.source.item)) {
                        dims.push({
                            "type": "entity",
                            "id": this.getPath(definition, d.source.item),
                            'name': d.source.item.name,
                            'bin': d.bin
                        });
                    } else {
                        const p = d.source.item as Property;

                        dims.push({
                            "type": "property",
                            "id": this.getPath(definition, d.source.item),
                            'name': p.property,
                            'stat': isStats(d.source.item) ? d.source.sub : null,
                            'bin': d.bin
                        });
                    }                  
                }
            });
        }

        return dims;
    }

    getMeasureQueryFromConfig(definition: Definition, measures: IMeasure[]): IDwMeasure[] {
        let items: any[] = [];

        console.log('getMeasureQueryFromConfig in', measures);

        if(measures) {
            measures.forEach((m: IMeasure) => {
                if(m.source && m.source.item) {
                    if(isEntity(m.source.item)) {
                        items.push({
                            type: "entity",
                            id: this.getPath(definition, m.source.item),
                            aggregation: m.aggregation
                        });
                    } else {
                        const property = m.source.item as Property;

                        if(isStats(m.source.item)) {
                            if(typeof m.aggregation !== 'undefined') {
                                items.push({
                                    type: "property",
                                    id: this.getPath(definition, m.source.item),
                                    stat: m.source.sub,
                                    name: property.property,
                                    aggregation: m.aggregation
                                });
                            } else {
                                items.push({
                                    type: "property",
                                    id: this.getPath(definition, m.source.item),
                                    name: property.property,
                                    stat: m.source.sub
                                });
                            }
                        } else {
                            if(typeof m.aggregation !== 'undefined') {
                                items.push({
                                    type: "property",
                                    id: this.getPath(definition, m.source.item),
                                    name: property.property,
                                    aggregation: m.aggregation
                                });
                            } else {
                                items.push({
                                    type: "property",
                                    id: this.getPath(definition, m.source.item),
                                    name: property.property,
                                    bin: m.source.sub
                                });
                            }
                        }
                    }
                }
            });
        }

        console.log('getMeasureQueryFromConfig out', items);

        return items;
    }

    getFilterQueryFromConfig(definition: Definition, config: IFilter[]): IDwFilter[] {
        let filters: IDwFilter[] = [];

        if(config) {
            config.forEach((filter: IFilter) => {
                if (filter.source.item) {
                    filters.push({
                        type: isEntity(filter.source.item) ? "entity" : "property",
                        id: this.getPath(definition, filter.source.item, filter.source.sub),
                        name: isEntity(filter.source.item) ? filter.source.item.name : (filter.source.item as Property).property,
                        operation: filter.operation!,
                        value: this.filterValueConverter(filter.source.item, filter.operation!, filter.value!)
                    });
                }
            });
        }

        return filters;
    }

    // handle now, comma separated lists, ...
    //
    filterValueConverter(item:any, operation:string, value:string) {
        // special time macro
        if(isTimestampProperty(item) && value.toLocaleLowerCase() === 'now') {
            return moment().format('YYYY-MM-DD HH:mm:ss');
        }

        // convert comma separated items to an array.
        // it would be great if the operation could give a hint
        // on how to perform the conversion...or this conversion
        // should be done in the configuration components?
        //
        const arrayOperations = ['in', 'between'];
        if(arrayOperations.includes(operation)) {
            return value.split(',').map((v:string) => v.trim());
        }

        return value.trim();
    }

    // Get the path to the variable. not handling nesting.
    //
    getPath(definition: Definition, item: Property | Entity, subItem: string | null = null): string {
       /* if (item.name === definition.name) {
            return item.name;
        }*/

        if(isEntity(item)) {
            if(subItem != null) {
                return `${definition.name}:${item.name}[${subItem}]`
            }

            return `${definition.name}:${item.name}`;
        } else {
            const property = item as Property;
            
            if(subItem != null) {
                return `${definition.name}:${property.id}[${subItem}]`
            }
    
            return `${definition.name}:${property.id}`;
        }   
    }
}

export default QueryProvider;